export const PDF_ACTION = {
  VIEW: "view",
  SAVE: "save",
};

export const handlePdf = (
  doc,
  action = PDF_ACTION.VIEW,
  fileName = "document.pdf"
) => {
  if (!doc) return;

  switch (action) {
    case PDF_ACTION.SAVE:
      doc.save(fileName);
      break;

    case PDF_ACTION.VIEW:
    default: {
      const pdfUrl = doc.output("bloburl");
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
      break;

      
    }
  }
};